import React from 'react';
import { Box, useRadio } from '@chakra-ui/react'
import { RadioCardProps } from '../../../types/ui';

export function RadioCard({ type,boxProps, radioProps, ...props}: RadioCardProps) {  
    const { getInputProps, getCheckboxProps } = useRadio(radioProps);

    const checkedStyles = {
      'card': { 
        borderColor: 'blue.600', 
        color: 'blue.600', 
        hover:  { boxShadow:' 0 2px 12px 2px rgba(0,0,0,0.15) !important' }
      },
      'badge': { borderColor: 'blue.600', color: 'blue.600', hover: undefined }
    };
  
    const input = getInputProps()
    const checkbox = getCheckboxProps();
  
    return (
      <Box as='label'>
        <input {...input} />
        <Box
            {...checkbox}
            {...props}
            cursor='pointer'
            borderWidth={boxProps.borderWidth || '1px'}
            borderRadius={boxProps.borderRadius || 'md'}
            _checked={checkedStyles[type]}
            width={boxProps.width || '660px'}
            marginBottom={boxProps.marginBottom || '16px'}
            backgroundColor='#fff'
            padding={boxProps.padding || '30px'}
            boxShadow={type === 'card' ? '0 2px 8px 0 rgba(0,0,0,0.09)' : ''}
            display={'flex'}
            justifyContent={boxProps.justifyContent || 'space-between'}
            alignItems={'center'}
            _hover={{ cursor: 'pointer', ...checkedStyles[type].hover}}
            _focus={{ boxShadow: 'none' }}
            px={boxProps.px || 5}
            py={2}
        >
          {props.children}
        </Box>
      </Box>
    )
  }